export const SEND_TOAST = 'SEND_TOAST'
export const CLEAR_TOAST_DATA = 'CLEAR_TOAST_DATA'

export const SendToast = (payload) => {
  return {
    type: SEND_TOAST,
    payload
  }
}

export const ClearToastData = () => {
  return {
    type: CLEAR_TOAST_DATA
  }
}
